<template>
  <Layout>
    <div class="row">
      <div class="col-sm">
        <div class="card" v-if="!isLoading">
          <div class="card-header">
            <div class="icon-title">
              <div class="icon-holder">
                <img src="../assets/images/usersOutline.svg" />
              </div>
              <span>{{$t('total_experts')}}</span>
            </div>
          </div>
          <div class="card-body">
            <div class="chart-stats">
              <span class="chart-value">{{ data.header.totalExperts}}</span>
              <img src="../assets/images/upTrend.svg" alt="Up Trend"/>
              <span class="chart-percent up">43%</span>
            </div>
          </div>
        </div>

        <free-style-shimmer
            v-else
            height="140px"
            width="100%"
            border-radius="20px"
            color="#EAECF0"
        />

      </div>
      <div class="col-sm">
        <div class="card" v-if="!isLoading">
          <div class="card-header">
            <div class="icon-title">
              <div class="icon-holder">
                <img src="../assets/images/calendar.svg" />
              </div>
              <span>{{$t('scheduled_sessions')}}</span>
            </div>
          </div>
          <div class="card-body">
            <div class="chart-stats">
              <span class="chart-value">{{ data.header.totalScheduledSessions }}</span>
              <img src="../assets/images/upTrend.svg" alt="Up Trend"/>
              <span class="chart-percent up">32%</span>
            </div>
          </div>
        </div>

        <free-style-shimmer
            v-else
            height="140px"
            width="100%"
            border-radius="20px"
            color="#EAECF0"
        />

      </div>
      <div class="col-sm">
        <div class="card" v-if="!isLoading">
          <div class="card-header">
            <div class="icon-title">
              <div class="icon-holder">
                <img src="../assets/images/programs.svg" />
              </div>
              <span>{{$t('total_sessions')}}</span>
            </div>
          </div>
          <div class="card-body">
            <div class="chart-stats">
              <span class="chart-value">{{ data.header.totalSessions }}</span>
              <img src="../assets/images/downTrend.svg" alt="Down Trend"/>
              <span class="chart-percent down">2%</span>
            </div>
          </div>
        </div>

        <free-style-shimmer
            v-else
            height="140px"
            width="100%"
            border-radius="20px"
            color="#EAECF0"
        />
      </div>
    </div>
    <div class="table-holder">
      <h3 class="table-title">{{$t('all_experts')}}</h3>
      <ExpertTable
          :loading="isLoading"
          :add-new-user="showAddUserModal"
          :experts="tableData"
          :current-sort="currentSort"
          :on-sort="handleSort"
          :on-download="handleDownloadRequest"
      />
      <ExpertModal :visible="addUserModal" :on-hide="hideAddUserModal" :refresh-callback="() => handlePage(1)"/>
    </div>

    <div class="pagination-align-center">
      <Pagination :current-page="currentPage" :total-items="!isLoading ? data.data.data.length : 0" :per-page="20" :on-page-change="handlePage"/>
    </div>
  </Layout>
</template>

<script>
import BarChart from '@/components/charts/BarChart.vue'
import Layout from "@/components/layouts/Layout.vue";
import AvatarArray from "@/components/AvatarArray.vue";
import ExpertTable from "@/components/tables/Expert/ExpertTable.vue";
import ExpertModal from "@/components/modals/ExpertModal.vue";
import expertService from "@/service/expertService";
import Pagination from "@/components/Pagination.vue";
import {handleErrorResponse} from "@/utils/utils";

export default {
  name: 'Home',
  components: {
    Pagination,
    ExpertModal,
    ExpertTable,
    AvatarArray,
    Layout,
    BarChart,
  },
  data() {
    return {
      isLoading: true,
      addUserModal: false,
      data: {},
      tableData: [],
      currentPage: 1,
      currentSort: {
        column: null,
        direction: null
      }
    }
  },
  watch: {
    $route() {
      this.handlePage(1);
    }
  },
  mounted() {
    // URL'den sort parametrelerini oku
    const routeQuery = this.$route.query;
    if (routeQuery.sortBy && routeQuery.sortDirection) {
      this.currentSort = {
        column: routeQuery.sortBy,
        direction: routeQuery.sortDirection
      };
    }
  },
  methods: {
    handleSort(column, direction) {
      this.currentSort = {
        column: column,
        direction: direction
      };

      // URL query'yi güncelle
      const query = { ...this.$route.query };

      if (column && direction) {
        query.sortBy = column;
        query.sortDirection = direction;
      } else {
        delete query.sortBy;
        delete query.sortDirection;
      }

      this.$router.push({ query });

      // Sayfayı yeniden yükle
      this.handlePage(1);
    },

    showAddUserModal() {
      this.addUserModal = true;
    },
    hideAddUserModal() {
      this.addUserModal = false;
    },
    handlePage(page) {
      if (this.isLoading && this.currentPage !== 1) return;

      this.isLoading = true;
      this.currentPage = page;

      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.searchText) {
        tempFilters.push({
          key: 'searchText',
          value: routeQuery.searchText
        });
      }

      if (routeQuery.addedDate) {
        tempFilters.push({
          key: 'addedDate',
          value: routeQuery.addedDate
        });
      }

      if (routeQuery.addedDateEnd) {
        tempFilters.push({
          key: 'addedDateEnd',
          value: routeQuery.addedDateEnd
        });
      }

      // Sort parametrelerini ekle
      if (routeQuery.sortBy && routeQuery.sortDirection) {
        const orderByArray = [{
          column: routeQuery.sortBy,
          direction: routeQuery.sortDirection
        }];

        tempFilters.push({
          key: 'orderBy',
          value: orderByArray
        });

        // currentSort state'ini güncelle
        this.currentSort = {
          column: routeQuery.sortBy,
          direction: routeQuery.sortDirection
        };
      }

      expertService.getExperts(page, tempFilters).then((response) => {
        this.isLoading = false;
        this.data = response.data;
        this.tableData = response.data.data.data;
      });
    },

    handleDownloadRequest() {
      const filters = this.getCurrentFilters();

      expertService.exportExperts(filters)
          .then(response => {
            const blob = new Blob([response.data], {
              type: response.headers['content-type'] || 'application/vnd.ms-excel'
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            const fileName = `${this.$t('expert_report')}_${this.getFormattedDate()}.xls`;
            link.setAttribute('download', fileName);

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch(error => {
            handleErrorResponse(error, this.$snackbar);
          });
    },

    getFormattedDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}${month}${day}`;
    },

    getCurrentFilters() {
      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.searchText) {
        tempFilters.push({
          key: 'searchText',
          value: routeQuery.searchText
        });
      }

      if (routeQuery.addedDate) {
        tempFilters.push({
          key: 'addedDate',
          value: routeQuery.addedDate
        });
      }

      if (routeQuery.addedDateEnd) {
        tempFilters.push({
          key: 'addedDateEnd',
          value: routeQuery.addedDateEnd
        });
      }

      if (routeQuery.sortBy && routeQuery.sortDirection) {
        tempFilters.push({
          key: 'orderBy',
          value: [{
            column: routeQuery.sortBy,
            direction: routeQuery.sortDirection
          }]
        });
      }

      return tempFilters;
    }
  }
}
</script>

<style scoped>
.icon-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}

.icon-title span {
  font-family: 'euclid_medium', sans-serif;
  font-size: 18px;
  white-space: nowrap
}

.card {
  margin-bottom: 10px;
}

.icon-holder {
  background-color: #EAECF0;
  border-radius: 8px;
  height: 28px;
  width: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}

.icon-holder img {
  cursor: default;
}

.chart-stats {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 10px;
}

.chart-value {
  font-family: 'euclid_medium', sans-serif;
  font-size: 28px;
  margin-right: 10px;
}

.chart-percent {
  font-family: 'euclid_semi_bold', sans-serif;
  font-size: 12px;
  margin-left: 5px;
}

.chart-percent.up {
  color: #3DA33E;
}

.chart-percent.down {
  color: #F09460;
}

.table-holder {
  margin-top: 20px;
}

.table-title {
  font-family: 'euclid_medium', sans-serif;
  font-size: 20px;
  color: #040C2D;
  margin-bottom: 20px;
}
</style>
